<template>
	<div>
		<!-- 功能按钮 -->
		<buttonlist
			@help="help"
			@add="add"
			@reflash="reflash"
			@exps="exp"
			@del="delall"
			ref="SetBtn"
		></buttonlist>
		<!-- 功能按钮 -->
		<!-- 表格 -->
		<el-table
			id="xpane-0"
			:data="datajson"
			v-loading="loading"
			:highlight-current-row="false"
			show-overflow-tooltip="true"
			border
			stripe
			size="mini"
			:height="tableHeight"
			header-row-class-name="headerclass"
			@cell-dblclick="editInfo"
			tab-click="selectInfo(0)"
			@selection-change="handleSelectionChange"
			style="width: 100%; margin-top:0px"
			ref="singleTable"
		>
			<el-table-column  type="selection"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Exclusively_ID" label="ID" v-if="false"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Grade_Name" :label="$t('getapi[1095]')" width="80"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Alias_Name" :label="$t('getapi[2077]')" width="80"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Description" :label="$t('getapi[3263]')" width="80"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Remark" :label="$t('getapi[143]')" width="180"></el-table-column>
			<el-table-column :label="$t('getapi[6048]')" width="80">
				<template slot-scope="scope">
					<el-button :disabled="!btn.edit"  @click.native.prevent="edit(scope)" type="text" size="small">{{$t('getapi[34]')}}</el-button>
					<el-popconfirm :confirmButtonText="$t('getapi[6109]')" :cancelButtonText="$t('getapi[6851]')" icon="el-icon-info" iconColor="red" :title="$t('getapi[6049]')" @onConfirm="del(scope)">
						<el-button :disabled="!btn.del" slot="reference" type="text" size="small">{{$t('getapi[40]')}}</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
		<!-- 表格 -->
		<!-- 分页 -->
		<el-row class="page">
			<el-col :span="12">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:page-sizes="[50, 100, 200, 300, 400]"
					:page-size="PageSize"
					background
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</el-col>
			<el-col :span="12">
				<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
			</el-col>
		</el-row>
		<!-- 分页 -->
		<!-- 搜索弹框 -->
		<el-dialog v-dialogDrag :visible.sync="isVisible" title="通用查询器" width="30%" :close-on-click-modal="false">
			<el-tabs type="border-card">
				<el-tab-pane label="基本条件">
					<el-table :data="queryData" border height="400" size="mini" style="width: 100%;">
						<el-table-column show-overflow-tooltip prop="Field_Show_Name" label="选项名称" width="150"></el-table-column>
						<el-table-column label="条件值">
							<template slot-scope="scope">
								<input type="text" v-model="scope.row.query_Condition" style="border:none" />
							</template>
						</el-table-column>
					</el-table>
				</el-tab-pane>
				<el-tab-pane label="使用帮助"><div style="min-height: 400px; line-height: 30px;" v-html="hleptext"></div></el-tab-pane>
			</el-tabs>

			<span slot="footer" class="dialog-footer">
				<el-button @click="isVisible = false">{{$t('getapi[2054]')}}</el-button>
				<el-button type="primary" @click="intidata">保 存</el-button>
			</span>
		</el-dialog>
		<!-- 搜索弹框 -->
		<!-- 编辑弹框 -->
		<el-dialog v-dialogDrag :visible.sync="editvisi" :title="$t('getapi[6915]')" width="30%" :close-on-click-modal="false">
			<el-divider></el-divider>
			<div :style="{border:'1px solid #DCDFE6'}">
			<table>
				<tr>
					<td>{{$t('getapi[1095]')}}</td>
					<td><el-input v-model="formInline.grade_name" type="text" size="mini" ></el-input></td>
					<td>{{$t('getapi[2077]')}}</td>
					<td><el-input v-model="formInline.alias_name" type="text" size="mini"></el-input></td>
				</tr>
				<tr>
					<td>{{$t('getapi[3263]')}}</td>
					<td colspan="3"><el-input v-model="formInline.description" type="text" size="mini" ></el-input></td>
				</tr>
				<tr>
					<td>{{$t('getapi[143]')}}</td>
					<td colspan="3"><el-input v-model="formInline.remark" type="text" size="mini"></el-input></td>
				</tr>
			</table>
			</div>
			<el-divider></el-divider>

			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="editvisi = false">{{$t('getapi[2054]')}}</el-button>
				<el-button size="small" type="primary" @click="sava">{{$t('getapi[937]')}}</el-button>
			</span>
		</el-dialog>
		<!-- 编辑弹框 -->
	</div>
</template>

<script>
import Common from '@/components/Common';
export default {
	name: 'supplygrade',
    computed: {
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
		return {
			formInline: {				            
				exclusively_id: 0,
				description: '',
				alias_name: '',
				grade_name: '',
				create_person: '',
				create_time: '',
				modify_person: '',
				modify_time: '',
				showing_sequence: 0,
				remark: '',
			},
			ids: '',
			cgzb: [],
			showloading: '',
			isVisible: false,
			editvisi: false,
			DbTbNames: '', //表名
			datajson: [],
			PageIndex: 1,
			PageSize: this.$http.getPageSize('supplygrade'),
			SelectIndex: 1,
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			isShowEdit: false, // 是否显示编辑页面
			dataSetDetail: {}, // 编辑页面数据详情
			queryData: [], // 查询数组
			selectIDData: '', // 选择的数据的ID集合
			tracetype: 0, //跟踪类别
			url: '', // 零件图路径
			isEdit: true ,// 是否新增
			btn: {
				del: false,
				edit: false
			},
            scrollTop:0,
		};
	},
	create() {},
	beforeMount() {
		// console.log('beforeMount');
		// this.getqwlist();
	},
    watch: {
        datajson: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(0)
            })
        },
    },
	mounted() {
		console.log('mounted');
		let that = this;
		that.intidata();
		that.authority();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1095]"),this.$t("getapi[11]"));
        },
		//按钮操作权限
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
			//只读权
			if (that.$limits.ReadOnlyRights('plv2', 41, 1)) {
				that.$refs.SetBtn.SetButtonEnable('refresh');
			}
			//操作权
			let ilimits = that.$limits.UnOperationAuthority('plv2', 41, 1);
			// limits说明：、2 编辑权限、3 删除权限
			switch (ilimits) {
				case 2:
					that.btn.edit = true;
					that.btn.del = false;
					that.$refs.SetBtn.SetButtonEnable('create,save,refresh');
					break;
				case 3:
					that.btn.edit = true;
					that.btn.del = true;
					that.$refs.SetBtn.SetButtonEnable('create,save,refresh,del');
					break;
				default:
					break;
			}
		},
		//修改页数
		handleSizeChange(val) {
			this.PageSize = val;
            this.$http.savePageSize('supplygrade',val)
			this.intidata();
			this.authority();
		},
		//跳页
		handleCurrentChange(val) {
			this.PageIndex = val;
			this.intidata();
			this.authority();
		},
		//编辑
		editInfo(row) {
			let that = this;
		},
		handleSelectionChange(val) {
			let that = this;
			that.selectIDData = '';
			for (let i = 0; i < val.length; i++) {
				that.selectIDData += val[i].exclusively_id + ',';
			}
			console.log(that.selectIDData);
		},
		// 获取数据
		intidata() {
			let that = this;
			that.loading = true;
			this.isVisible = false;
			that.$http.urlpost('Basic/Supply/GetVenderGradeList', {}, function(res) {
				console.log(res);
				if (res.Success == 1) {
					that.datajson = res.DataContent;
					that.total = res.Totals;
					that.DbTbNames = res.DbTbNames;
				}
				that.loading = false;
			});
		},
		sava() {
			let that = this;
			that.loading = true;
			let parm = new Array();
			parm.push(that.formInline);
			console.log(parm);
			that.$http.urlpost('Basic/Supply/SaveVenderGrade', parm, function(res) {
				console.log(res);
				if (res.Success == 1) {
					that.$message.success(that.$t('getapi[3153]'));//'保存成功'
					that.editvisi = false;
					that.intidata();
				}
				that.loading = false;
			});
		},
		delf() {
			let that = this;
			let parm = {
				ids: that.ids
			};
			console.log(parm);
			that.$http.urlpost('Basic/Supply/DeleteVenderGradeByID', parm, function(res) {
				console.log(res);
				if (res.Success == 1) {
					that.$message.success(that.$t('getapi[659]'));//'删除成功'
					that.intidata()
					/*that.datajson.forEach(function(item, index) {
						if (that.ids.indexOf(item.exclusively_id) >= 0) {
							that.datajson.splice(index, 1);
						}
					});*/
				}
			});
		},
		// 获取查询条件
		getqwlist() {
			let that = this;
			that.$http.urlpost('Sch/PParts/QWList', {}, function(res) {
				that.queryData = res.DataContent;
			});
		},
		// 编辑
		edit(jsd) {
			console.log(jsd);
			this.formInline.description = jsd.row.Description;
			this.formInline.grade_name = jsd.row.Grade_Name;
			this.formInline.alias_name = jsd.row.Alias_Name;
			this.formInline.remark = jsd.row.Remark;
			this.formInline.exclusively_id = jsd.row.Exclusively_ID;
			this.editvisi = true;
		},
		// 删除
		del(jsd) {
			this.ids = jsd.row.Exclusively_ID + ',';
			this.delf();
			this.intidata();
		},
		//批量删除
		delall() {
			let that = this;
			that.ids = this.selectIDData;
			that.$confirm(that.$t('getapi[8594]'), that.$t('getapi[194]'), {//'此操作将永久删除该数据, 是否继续?'
				confirmButtonText: that.$t('getapi[1146]'),
				cancelButtonText: that.$t('getapi[2054]'),
				type: 'warning'
			})
				.then(() => {
					that.delf();
				})
				.catch(() => {});
		},
		// 新增
		add() {
			this.formInline.description ='';
			this.formInline.grade_name = '';
			this.formInline.alias_name = '';
			this.formInline.remark = '';
			this.formInline.exclusively_id = 0;
			this.editvisi = true;
		},
		// 刷新
		reflash() {
			this.intidata();
		},
		//导出·
		exp() {
		}
	}
};
</script>

<style lang="scss" scoped>

table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
.el-form--inline .el-form-item {
	display: flex;
}

.tb-edit .el-input {
	display: none;
}

.tb-edit .current-row .el-input {
	display: block;
}

.tb-edit .current-row .el-input + span {
	display: none;
}

.el-table .hidden-row {
	display: none;
}
</style>
